module.exports = __webpack_public_path__ + "img/82.bbd5bf90.jpg";